var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1",
    clipPath: "url(#clip0_311_275)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.4632 43.0603L43.5472 36.1443L38.137 41.5566L35.0734 38.4929L40.4835 33.0806L37.4199 30.0169L32.0097 35.4271L28.946 32.3634L34.3562 26.9533L31.2925 23.8896L25.8824 29.2998L22.8187 26.2361L28.2289 20.8259L25.1652 17.7623L19.755 23.1746L16.6914 20.1109L22.1015 14.6986L18.9252 11.5223L13.515 16.9324L10.4514 13.8688L15.8615 8.4586L8.94553 1.5426C7.44186 0.0389351 5.20153 -0.405232 3.23853 0.407268C1.27336 1.21977 0.00585938 3.11777 0.00585938 5.24544V51.9999H46.7604C48.8859 51.9999 50.7839 50.7303 51.5985 48.7673C52.4132 46.8043 51.9669 44.5639 50.4632 43.0603ZM13.0059 38.9999V27.2696L24.7362 38.9999H13.0059Z",
    fill: "#e88d78"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_311_275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.82bd6dc23d7960a9711cd213f97c1fae.svg";
export { ForwardRef as ReactComponent };